import { useState } from 'react';
import { AIConsoleProvider } from '../contexts/AIConsoleContext';
import { GlobalSettingsBar, JailbreakTestPanel, AgenticTestPanel } from './ai-console';
import { ProviderManagementTab } from './llm';

type TabId = 'providers' | 'jailbreak' | 'agentic';

const TABS: { id: TabId; label: string }[] = [
  { id: 'providers', label: 'Providers' },
  { id: 'jailbreak', label: 'Jailbreak' },
  { id: 'agentic', label: 'Agentic' },
];

function AIConsoleContent() {
  const [activeTab, setActiveTab] = useState<TabId>('providers');

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-6">
        <h1 className="heading-page text-neutral-900 dark:text-neutral-50">
          AI 控制台
        </h1>
        <p className="body-small text-neutral-500 dark:text-neutral-400 mt-1">
          Provider 管理、Jailbreak 測試、Agent 整合測試
        </p>
      </div>

      {/* Global Settings Bar */}
      <div className="mb-6">
        <GlobalSettingsBar />
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-neutral-200 dark:border-neutral-700 mb-6">
        <nav className="flex gap-4" aria-label="Tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === tab.id
                  ? 'border-primary-500 text-primary-600 dark:text-primary-400'
                  : 'border-transparent text-neutral-500 hover:text-neutral-700 hover:border-neutral-300 dark:text-neutral-400 dark:hover:text-neutral-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'providers' && <ProviderManagementTab />}
      {activeTab === 'jailbreak' && <JailbreakTestPanel />}
      {activeTab === 'agentic' && <AgenticTestPanel />}
    </div>
  );
}

export function AIConsolePage() {
  return (
    <AIConsoleProvider>
      <AIConsoleContent />
    </AIConsoleProvider>
  );
}
